import { IssueDrawerData, IssueStatus, IssueType } from '@/utils/type';
import { createSlice } from '@reduxjs/toolkit';
import { DRAWER_INFO } from '../actions/common';

const initState: {
  list: IssueDrawerData[];
  takeOverUserName?: string;
  takeOverCockpitNumber?: string;
} = {
  list: [],
  takeOverUserName: undefined,
  takeOverCockpitNumber: undefined,
};

const issueData = createSlice({
  name: 'issueData',
  initialState: initState,
  reducers: {
    setTakeOverInfo: (state, action) => {
      const { takeOverUserName, takeOverCockpitNumber } = action.payload;
      state.takeOverUserName = takeOverUserName;
      state.takeOverCockpitNumber = takeOverCockpitNumber;
    },
    clearTakeOverInfo: (state) => {
      state.takeOverUserName = undefined;
      state.takeOverCockpitNumber = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(DRAWER_INFO, (state, action: any) => {
      const res = action.payload;
      const { issueList } = res?.data || {};
      state.list = issueList;
    });
  },
});

export const { setTakeOverInfo, clearTakeOverInfo } = issueData.actions;
export default issueData.reducer;
